import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import { Button } from "react-bootstrap"

import { withSampleConfig } from "../../../config/SampleConfigProvider"
import { hideModal, showModal } from "../../../shared_components/utils"
import ModalSamplePoint from "./ModalSamplePoint"
import SampleSchedule from "./SampleSchedule"
import { getFormattedMessage } from "../../shared_components_registration"

function SampleScheduleTab({
  intl,
  user_permissions = [], // From SampleConfigProvider
  getSamplePoints, // From SampleConfigProvider
  isNSView = false, // From SampleConfigProvider
}) {
  const [showSamplePointModal, setShowSamplePointModal] = useState(false)

  return (
    <>
      <div className={"row"}>
        {/* New Sample Point Modal */}
        {showSamplePointModal && user_permissions.includes("add_samplingpoint") && (
          <ModalSamplePoint
            show={showSamplePointModal}
            onHide={() => hideModal(setShowSamplePointModal)}
            sampling_point={null}
            intl={intl}
          />
        )}
        <div className={"col-6"}>
          <div style={{ margin: "5px 0px" }}>
            <span className={"fa fa-calendar"} />
            &nbsp;&nbsp;
            {getFormattedMessage(
              `samplemanagement.tab.${isNSView ? "ns" : "sample"}.schedule`,
              `${isNSView ? "NS" : "Sample"} Schedule`,
            )}
          </div>
        </div>
        <div className={"col-6"} align={"right"}>
          <Button
            variant={"outline-primary"}
            size={"sm"}
            onClick={(e) => {
              e.preventDefault()
              getSamplePoints()
            }}
            style={{ marginRight: "5px" }}
          >
            <span className={"fa fa-refresh"} />
            &nbsp;
            <FormattedMessage id={"general.refresh"} description={"Data Transfer Refresh Data Button"} />
          </Button>
          <Button
            variant={"primary"}
            size={"sm"}
            disabled={!user_permissions.includes("add_samplingpoint")}
            onClick={(e) => {
              e.preventDefault()
              showModal(setShowSamplePointModal)
            }}
          >
            <span className={"fa fa-plus text_white"} />
            &nbsp;
            {getFormattedMessage("general.create", "Create")}
          </Button>
        </div>
      </div>
      <hr style={{ margin: "10px 0px 25px 0px" }} />
      <SampleSchedule allowSelection={false} allowActions={true} />
    </>
  )
}

export default withSampleConfig(SampleScheduleTab)
